import { Router } from '@angular/router'
import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { Subscription } from 'rxjs'

import { ApiError, AuthApiService, PaymentsService, ApiResponse, HttpStatusCodesEnum } from '@spa/api'
import { DialogActionsEnum, DialogComponent, DialogConfigInterface } from 'appShared/components'
import { FormInterface, PermissionRuleInterface } from 'appShared/interfaces'
import { BulkPaymentStatusesForm } from 'appEntries/panel/forms'
import { FormComponent } from 'appShared/widgets'
import { PanelPaymentsEditMessages } from 'appAssets/messages'
import { TransactionStatusesFormErrorStatesEnum } from 'appEntries/panel/enums'
import { BulkPaymentModalDataInterface, BulkPaymentStatusUpdateTotalInterface } from 'appEntries/panel/interfaces'

@Component({
  selector: 'app-payment-bulk-update-status',
  templateUrl: './payment-bulk-update-status.component.html',
  styleUrls: ['./payment-bulk-update-status.component.scss'],
})
export class PaymentBulkUpdateStatusComponent
  extends DialogComponent<PaymentBulkUpdateStatusComponent>
  implements OnInit, OnDestroy, FormInterface
{
  private bulkUpdateSubscription: Subscription
  public config: DialogConfigInterface
  public payments: BulkPaymentModalDataInterface[]
  public paymentStatusesForm: BulkPaymentStatusesForm
  public numberOfPayment: number
  public totalGroups: BulkPaymentStatusUpdateTotalInterface[]
  public updateToCancelledPermissionRule: PermissionRuleInterface
  constructor(
    protected router: Router,
    private paymentsService: PaymentsService,
    private authApiService: AuthApiService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      config: DialogConfigInterface
      payments: BulkPaymentModalDataInterface[]
      updateToCancelledPermissionRule: PermissionRuleInterface
    },
    public dialogRef: MatDialogRef<PaymentBulkUpdateStatusComponent>,
  ) {
    super(dialogRef)

    this.config = data.config
    this.payments = data.payments
    this.numberOfPayment = data.payments.length
    this.totalGroups = this.payments.reduce(
      (totals: BulkPaymentStatusUpdateTotalInterface[], item: BulkPaymentModalDataInterface) => {
        const currency = totals.find((c) => c.currency === item.payment.currencyCode)
        if (currency) {
          currency.amount += +item.payment.amount
        } else {
          totals.push({ currency: item.payment.currencyCode, amount: +item.payment.amount })
        }

        return totals
      },
      [],
    )
    this.updateToCancelledPermissionRule = data.updateToCancelledPermissionRule
  }

  initForm(): void {
    this.paymentStatusesForm = new BulkPaymentStatusesForm(this.paymentsService)
    this.paymentStatusesForm.initForm(this.payments)
  }
  getFormMessages(controlLabel?: string, controlLength?: number): { [key: string]: string } {
    return FormComponent.getFormMessages(controlLabel)
  }

  private changeStatus(): void {
    if (this.validateForm()) {
      this.startLoading(() => {
        this.bulkUpdateSubscription = this.paymentStatusesForm
          .createRequest(
            this.payments,
            this.updateToCancelledPermissionRule.permissions,
            !this.authApiService.getAuthenticatedUser() ? [] : this.authApiService.getAuthenticatedUser().permissions,
          )
          .subscribe((response: ApiResponse<ApiError[] | boolean>) => {
            if (response.status === HttpStatusCodesEnum.Ok) {
              this.config.process.failed = false
              this.config.process.succeedMessage =
                PanelPaymentsEditMessages.BulkPaymentStatusChangeSucceeded.message.replace(
                  '<<total>>',
                  '' + this.payments.length,
                )
            } else if (response.status === TransactionStatusesFormErrorStatesEnum.UpdateStatusToCancelledRejected) {
              this.config.process.failed = true
              this.config.process.failedMessage = PanelPaymentsEditMessages.UpdateStatusToCancelledRejected.message
            } else {
              this.config.process.failed = true
              const messages = []
              const errors = response.data as ApiError[]
              if (errors.findIndex((e: ApiError) => e.status === HttpStatusCodesEnum.NoContent) > -1) {
                messages.push(
                  PanelPaymentsEditMessages.BulkPaymentStatusChangeSucceeded.message.replace(
                    '<<total>>',
                    '' + errors.filter((e: ApiError) => e.status === HttpStatusCodesEnum.NoContent).length,
                  ),
                )
              }
              if (
                errors.findIndex(
                  (e: ApiError) => e.status === TransactionStatusesFormErrorStatesEnum.UpdateStatusUnavailableTrigger,
                ) > -1
              ) {
                messages.push(
                  PanelPaymentsEditMessages.BulkPaymentStatusChangeFailedByUnavailableStatus.message.replace(
                    '<<total>>',
                    '' +
                      errors.filter(
                        (e: ApiError) =>
                          e.status === TransactionStatusesFormErrorStatesEnum.UpdateStatusUnavailableTrigger,
                      ).length,
                  ),
                )
              }
              if (
                errors.findIndex(
                  (e: ApiError) => e.status === TransactionStatusesFormErrorStatesEnum.UpdateStatusFailed,
                ) > -1
              ) {
                messages.push(
                  PanelPaymentsEditMessages.BulkPaymentStatusChangeFailed.message.replace(
                    '<<total>>',
                    '' +
                      errors.filter(
                        (e: ApiError) => e.status === TransactionStatusesFormErrorStatesEnum.UpdateStatusFailed,
                      ).length,
                  ),
                )
              }

              this.config.process.failedMessage = messages.join('</br>')
            }

            this.config.process.finished = true
            this.config.process.loading = false
          })
      })
    }
  }

  ngOnInit(): void {
    this.initForm()
  }

  ngOnDestroy(): void {
    if (this.bulkUpdateSubscription) {
      this.bulkUpdateSubscription.unsubscribe()
    }
  }

  validateForm(): boolean {
    return this.paymentStatusesForm.validateForm(this.getFormMessages)
  }

  onFormSubmit(action?: number): void {
    switch (action) {
      case DialogActionsEnum.Decline:
        this.dialogRef.close(false)
        break
      case DialogActionsEnum.ProcessFinished:
        this.dialogRef.close(this.config.process.finished)
        break
      case DialogActionsEnum.Confirm:
        this.changeStatus()
        break
    }
  }
}

